import { render } from "./GroupMembersTab.vue?vue&type=template&id=50ae2074&scoped=true"
import script from "./GroupMembersTab.vue?vue&type=script&lang=js"
export * from "./GroupMembersTab.vue?vue&type=script&lang=js"

import "./GroupMembersTab.vue?vue&type=style&index=0&id=50ae2074&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ae2074"]])

export default __exports__